/*
  Extended from femtoJS https://vladocar.github.io/femtoJS/

  This utils must not have anything other than DOM Manipulation
*/

// CSS Property to Utility Class Mappings (for CSP compliance - no inline styles)
const CLASS_MAPPINGS = {
  width: {
    0: "w-0",
    "0px": "w-0",
    "50px": "w-50px",
    "50%": "w-50",
    "70px": "w-70px",
    "75px": "w-75px",
    "85px": "w-85px",
    "100px": "w-100px",
    "110px": "w-110px",
    "120px": "w-120px",
    "130px": "w-130px",
    "140px": "w-140px",
    "145px": "w-145px",
    "150px": "w-150px",
    "160px": "w-160px",
    "170px": "w-170px",
    "180px": "w-180px",
    "190px": "w-190px",
    "200px": "w-200px",
    "210px": "w-210px",
    "215px": "w-215px",
    "220px": "w-220px",
    "230px": "w-230px",
    "240px": "w-240px",
    "250px": "w-250px",
    "260px": "w-260px",
    "270px": "w-270px",
    "280px": "w-280px",
    "290px": "w-290px",
    "295px": "w-295px",
    "300px": "w-300px",
    "305px": "w-305px",
    "310px": "w-310px",
    "313px": "w-313px",
    "315px": "w-315px",
    "320px": "w-320px",
    "325px": "w-325px",
    "330px": "w-330px",
    "335px": "w-335px",
    "340px": "w-340px",
    "350px": "w-350px",
    "360px": "w-360px",
    "370px": "w-370px",
    "375px": "w-375px",
    "380px": "w-380px",
    "390px": "w-390px",
    "392px": "w-392px",
    "400px": "w-400px",
    "410px": "w-410px",
    "420px": "w-420px",
    "430px": "w-430px",
    "440px": "w-440px",
    "450px": "w-450px",
    "460px": "w-460px",
    "470px": "w-470px",
    "480px": "w-480px",
    "490px": "w-490px",
    "500px": "w-500px",
    "510px": "w-510px",
    "520px": "w-520px",
    "525px": "w-525px",
    "530px": "w-530px",
    "535px": "w-535px",
    "540px": "w-540px",
    "550px": "w-550px",
    "560px": "w-560px",
    "570px": "w-570px",
    "580px": "w-580px",
    "590px": "w-590px",
    "600px": "w-600px",
    "610px": "w-610px",
    "620px": "w-620px",
    "630px": "w-630px",
    "640px": "w-640px",
    "650px": "w-650px",
    "660px": "w-660px",
    "670px": "w-670px",
    "680px": "w-680px",
    "690px": "w-690px",
    "700px": "w-700px",
    "710px": "w-710px",
    "720px": "w-720px",
    "730px": "w-730px",
    "740px": "w-740px",
    "750px": "w-750px",
    "760px": "w-760px",
    "770px": "w-770px",
    "780px": "w-780px",
    "790px": "w-790px",
    "800px": "w-800px",
    "802px": "w-802px",
    "810px": "w-810px",
    "820px": "w-820px",
    "830px": "w-830px",
    "840px": "w-840px",
    "850px": "w-850px",
    "860px": "w-860px",
    "870px": "w-870px",
    "880px": "w-880px",
    "890px": "w-890px",
    "900px": "w-900px",
    "100%": "w-100",
    "99%": "w-99",
    "90%": "w-90",
    "80%": "w-80",
    "70%": "w-70",
    "60%": "w-60",
    "40%": "w-40",
    "30%": "w-30",
    "20%": "w-20",
    "15%": "w-15",
    "12%": "w-12",
    "10%": "w-10",
    auto: "w-auto",
    "fit-content": "w-fit-content",
    "max-content": "w-max-content",
  },
  height: {
    "10px": "h-10px",
    "15px": "h-15px",
    "20px": "h-20px",
    "25px": "h-25px",
    "35px": "h-35px",
    "50px": "h-50px",
    "55px": "h-55px",
    "100px": "h-100px",
    "100%": "h-100",
    "200px": "h-200px",
    "300px": "h-300px",
    "360px": "h-360px",
    "420px": "h-420px",
    "490px": "h-490px",
    "500px": "h-500px",
    "550px": "h-550px",
    auto: "h-auto",
  },
  display: {
    none: "d-n",
    block: "d-b",
    "inline-block": "d-ib",
    inline: "d-i",
    flex: "d-f",
  },
  visibility: { visible: "v-v", hidden: "v-h" },
  position: {
    static: "pos-static",
    relative: "pos-relative",
    absolute: "pos-absolute",
    fixed: "pos-fixed",
    sticky: "pos-sticky",
  },
  overflow: { hidden: "ov-hidden", auto: "ov-auto", scroll: "ov-scroll" },
  "overflow-x": { hidden: "ov-x-hidden", auto: "ov-x-auto" },
  "overflow-y": {
    hidden: "ov-y-hidden",
    auto: "ov-y-auto",
    scroll: "ov-y-scroll",
  },
  opacity: { 0.8: "op-0-8", 1: "op-1" },
  bottom: {
    0: "b-0",
    "0px": "b-0",
    "10px": "b-10",
  },
};

const WIDTH_CLASSES =
  "w-0 w-50px w-50 w-70px w-75px w-85px w-100px w-120px w-130px w-140px w-145px w-150px w-160px w-170px w-180px w-190px w-200px w-215px w-220px w-230px w-250px w-295px w-300px w-305px w-313px w-315px w-325px w-335px w-350px w-375px w-390px w-392px w-400px w-420px w-450px w-500px w-525px w-530px w-535px w-550px w-570px w-600px w-650px w-690px w-800px w-802px w-850px w-900px w-100 w-99 w-90 w-auto w-fit-content w-max-content";
const HEIGHT_CLASSES =
  "h-10px h-15px h-20px h-25px h-35px h-50px h-55px h-100px h-100 h-200px h-300px h-360px h-420px h-490px h-500px h-550px h-auto";
const POSITION_CLASSES =
  "pos-static pos-relative pos-absolute pos-fixed pos-sticky";
const OVERFLOW_CLASSES = "ov-hidden ov-auto ov-scroll";
const OVERFLOW_X_CLASSES = "ov-x-hidden ov-x-auto";
const OVERFLOW_Y_CLASSES = "ov-y-hidden ov-y-auto ov-y-scroll";
const DISPLAY_CLASSES = "d-n d-b d-ib d-i d-f";
const BOTTOM_CLASSES = "b-0 b-10";

// Helper function to remove all utility classes for a given CSS property
function removePropertyClasses(domInstance, property) {
  const map = {
    width: WIDTH_CLASSES,
    height: HEIGHT_CLASSES,
    position: POSITION_CLASSES,
    overflow: OVERFLOW_CLASSES,
    "overflow-x": OVERFLOW_X_CLASSES,
    "overflow-y": OVERFLOW_Y_CLASSES,
    display: DISPLAY_CLASSES,
    bottom: BOTTOM_CLASSES,
  };
  const classes = map[property];
  if (classes) {
    classes.split(/\s+/).forEach((c) => {
      if (c) domInstance.removeClass(c);
    });
  }
}

// Helper function to convert camelCase to kebab-case
function camelToKebab(str) {
  return str.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, "$1-$2").toLowerCase();
}

class DOM {
  constructor(selector, parent = document) {
    let elements;
    if (selector instanceof Element) {
      elements = [selector];
    } else if (typeof selector === "string") {
      const tagName = /^<(\w+)>$/.exec(selector);

      if (tagName !== null) {
        elements = [document.createElement(tagName[1])];
      } else {
        elements = [...document.querySelectorAll(selector)];
      }
    } else if (selector instanceof NodeList) {
      elements = selector;
    } else if (selector[Symbol.iterator]) {
      elements = [];
      for (const el of selector) {
        elements.push(...(el instanceof DOM ? el : [el]));
      }
    } else if (selector.matches) {
      elements = parent.querySelectorAll(selector);
    } else {
      throw new Error("Invalid selector", selector);
    }

    // Store the length property and assign elements to the current instance
    this.length = elements.length;
    for (let i = 0; i < this.length; i++) {
      this[i] = elements[i];
    }

    // Enable iterator on the current instance
    this[Symbol.iterator] = elements[Symbol.iterator].bind(elements);
  }

  // Method to get or set attributes
  attr(attrName, value) {
    if (value === undefined) {
      return this[0]?.getAttribute(attrName);
    } else {
      for (let i = 0; i < this.length; i++) {
        this[i].setAttribute(attrName, value);
      }
      return this;
    }
  }

  // Method to find an element by attribute
  findByAttr(attr, value) {
    const root = this && this[0] ? this[0] : document.body;
    if (root.hasAttribute(attr) && root.getAttribute(attr) == value) {
      return root;
    }
    let children = root.children;
    let element;
    for (let i = children.length; i--; ) {
      element = _$(children[i]).findByAttr(attr, value);
      if (element) {
        return element;
      }
    }
    return null;
  }

  // Method to get or set properties
  prop(propName, value) {
    if (value === undefined && this[0]) {
      return this[0][propName];
    } else {
      for (let i = 0; i < this.length; i++) {
        this[i][propName] = value;
      }
      return this;
    }
  }

  // Method to hide elements (uses utility class for CSP compliance)
  hide() {
    for (let i = 0; i < this.length; i++) {
      this.addClass("d-n");
    }
    return this;
  }

  // Method to show elements (uses utility class for CSP compliance)
  show() {
    for (let i = 0; i < this.length; i++) {
      this.removeClass("d-n");
      this[i].classList.remove("is-hidden");
    }
    return this;
  }

  // Method to get or set input values
  val(val) {
    if (val !== undefined) {
      for (let i = 0; i < this.length; i++) {
        this[i].value = val;
      }
      return this;
    } else {
      let result = "";
      for (let i = 0; i < this.length; i++) {
        result += this[i].value;
      }
      return result;
    }
  }

  // Method to get or set text content
  text(text) {
    if (text !== undefined) {
      for (let i = 0; i < this.length; i++) {
        this[i].textContent = text;
      }
      return this;
    } else {
      let result = "";
      for (let i = 0; i < this.length; i++) {
        result += this[i].textContent;
      }
      return result;
    }
  }

  // Method to get or set HTML content
  html(html) {
    if (html !== undefined) {
      // Sanitize HTML to remove inline styles for CSP compliance
      let sanitizedHtml = html;
      if (typeof html === "string") {
        // Remove inline style attributes to prevent CSP violations
        sanitizedHtml = html.replace(/\s+style\s*=\s*["'][^"']*["']/gi, "");
        // Also handle style attributes without quotes
        sanitizedHtml = sanitizedHtml.replace(/\s+style\s*=\s*[^\s>]+/gi, "");
      }

      for (let i = 0; i < this.length; i++) {
        this[i].innerHTML = sanitizedHtml;
      }
      return this;
    } else {
      let result = "";
      for (let i = 0; i < this.length; i++) {
        result += this[i].innerHTML;
      }
      return result;
    }
  }

  // Method to empty the elements
  empty() {
    this.html("");
    return this;
  }

  // Method to apply CSS styles (uses utility classes for CSP compliance)
  css(property, value, css) {
    // Third-argument css string overload is disallowed under CSP
    if (typeof css === "string") {
      console.warn(
        "DOM.css(): cssText overload is disallowed under CSP. Use utility classes instead."
      );
      return this;
    }

    // Get mode: value === undefined and property is a string
    if (value === undefined && typeof property === "string") {
      if (!this[0]) return undefined;
      const kebabProperty = camelToKebab(property);
      const computedStyle = window.getComputedStyle(this[0]);
      return computedStyle.getPropertyValue(kebabProperty);
    }

    // Set mode: value is provided
    if (value !== undefined) {
      // Normalize value: trim whitespace, handle "0px" -> "0"
      let normalizedValue = String(value).trim();
      if (normalizedValue === "0px") normalizedValue = "0";

      // Check if we have a mapping for this property and value
      const propMapping = CLASS_MAPPINGS[property];
      if (propMapping && propMapping[normalizedValue]) {
        // Use utility class if mapping exists
        const className = propMapping[normalizedValue];
        removePropertyClasses(this, property);
        this.addClass(className);
        return this;
      } else {
        // No utility class mapping found - use CSSOM (CSP-compliant)
        // This allows dynamic values to work without requiring utility classes for every possible value
        for (let i = 0; i < this.length; i++) {
          const kebabProperty = camelToKebab(property);
          this[i].style.setProperty(kebabProperty, normalizedValue);
        }
        return this;
      }
    }

    // Set mode: property is an object with multiple properties
    if (typeof property === "object" && property !== null) {
      for (const prop in property) {
        this.css(prop, property[prop]);
      }
      return this;
    }

    return this;
  }

  // Method to add a CSS class
  addClass(className) {
    for (let i = 0; i < this.length; i++) {
      this[i].classList.add(className);
    }
    return this;
  }

  // Method to remove a CSS class
  removeClass(className) {
    for (let i = 0; i < this.length; i++) {
      this[i].classList.remove(className);
    }
    return this;
  }

  // Method to toggle a CSS class
  toggleClass(className, condition) {
    for (let i = 0; i < this.length; i++) {
      this[i].classList.toggle(className, condition);
    }
    return this;
  }

  // Method to iterate over elements
  each(callback) {
    for (let i = 0; i < this.length; i++) {
      callback(this[i], i);
    }
    return this;
  }

  // Method to attach an event listener
  on(eventName, handler) {
    for (let i = 0; i < this.length; i++) {
      this[i].addEventListener(eventName, handler);
    }
    return this;
  }

  // Method to remove an event listener
  off(eventName, handler) {
    for (let i = 0; i < this.length; i++) {
      this[i].removeEventListener(eventName, handler);
    }
    return this;
  }

  // Method to append content
  append(content) {
    for (let i = 0; i < this.length; i++) {
      if (typeof content !== "string") {
        this[i].insertAdjacentElement("beforeend", content);
      } else {
        // Sanitize HTML to remove inline styles for CSP compliance
        let sanitizedContent = content.replace(
          /\s+style\s*=\s*["'][^"']*["']/gi,
          ""
        );
        sanitizedContent = sanitizedContent.replace(
          /\s+style\s*=\s*[^\s>]+/gi,
          ""
        );
        this[i].insertAdjacentHTML("beforeend", sanitizedContent);
      }
    }
    return this;
  }

  // Method to prepend content
  prepend(content) {
    for (let i = 0; i < this.length; i++) {
      if (typeof content !== "string") {
        this[i].insertAdjacentElement("afterbegin", content);
      } else {
        // Sanitize HTML to remove inline styles for CSP compliance
        let sanitizedContent = content.replace(
          /\s+style\s*=\s*["'][^"']*["']/gi,
          ""
        );
        sanitizedContent = sanitizedContent.replace(
          /\s+style\s*=\s*[^\s>]+/gi,
          ""
        );
        this[i].insertAdjacentHTML("afterbegin", sanitizedContent);
      }
    }
    return this;
  }

  // Method to insert content after each element
  after(content) {
    for (let i = 0; i < this.length; i++) {
      if (typeof content !== "string") {
        this[i].insertAdjacentElement("afterend", content);
      } else {
        // Sanitize HTML to remove inline styles for CSP compliance
        let sanitizedContent = content.replace(
          /\s+style\s*=\s*["'][^"']*["']/gi,
          ""
        );
        sanitizedContent = sanitizedContent.replace(
          /\s+style\s*=\s*[^\s>]+/gi,
          ""
        );
        this[i].insertAdjacentHTML("afterend", sanitizedContent);
      }
    }
    return this;
  }

  // Method to insert content before each element
  before(content) {
    for (let i = 0; i < this.length; i++) {
      if (typeof content !== "string") {
        this[i].insertAdjacentElement("beforebegin", content);
      } else {
        // Sanitize HTML to remove inline styles for CSP compliance
        let sanitizedContent = content.replace(
          /\s+style\s*=\s*["'][^"']*["']/gi,
          ""
        );
        sanitizedContent = sanitizedContent.replace(
          /\s+style\s*=\s*[^\s>]+/gi,
          ""
        );
        this[i].insertAdjacentHTML("beforebegin", sanitizedContent);
      }
    }
    return this;
  }

  // Method to get the parent elements
  parent() {
    const parentElems = [];
    for (let i = 0; i < this.length; i++) {
      if (!parentElems.includes(this[i].parentNode)) {
        parentElems.push(this[i].parentNode);
      }
    }
    return new DOM(parentElems);
  }

  // Method to find elements within the current elements
  find(selector, first) {
    if (first) {
      return this[0].querySelector(selector);
    }

    const foundElems = [];

    for (let i = 0; i < this.length; i++) {
      const elems = this[i].querySelectorAll(selector);
      for (let j = 0; j < elems.length; j++) {
        if (!foundElems.includes(elems[j])) {
          foundElems.push(elems[j]);
        }
      }
    }

    return new DOM(foundElems);
  }

  // closest(selector) {
  //   const foundElems = [];
  //   for (let i = 0; i < this.length; i++) {
  //     const elems = this[i].closest(selector);
  //     for (let j = 0; j < elems.length; j++) {
  //       if (!foundElems.includes(elems[j])) {
  //         foundElems.push(elems[j]);
  //       }
  //     }
  //   }
  //   return new DOM(foundElems);
  // }

  // Method to get the offset position of the first element
  offset() {
    const rect = this[0].getBoundingClientRect();
    return {
      top: rect.top + window.pageYOffset,
      left: rect.left + window.pageXOffset,
    };
  }

  // Method to remove the elements from the DOM
  remove() {
    for (let i = 0; i < this.length; i++) {
      this[i]?.parentNode?.removeChild(this[i]);
    }
    return this;
  }

  // Method to check if the first element matches a selector
  is(selector) {
    return this[0].matches(selector);
  }

  // Method to get the current element or its closest parent that matches a selector
  selfOrParent(selector) {
    if (this.is(selector)) {
      return new DOM(this[0]);
    } else {
      return this[0].closest(selector);
    }
  }

  // Method to filter out elements that don't match a selector
  not(selector) {
    const filteredElems = [];
    for (let i = 0; i < this.length; i++) {
      if (!this[i].matches(selector)) {
        filteredElems.push(this[i]);
      }
    }
    return new DOM(filteredElems);
  }

  // Method to filter elements that match a selector
  filter(selector) {
    const filteredElems = [];
    for (let i = 0; i < this.length; i++) {
      if (this[i].matches(selector)) {
        filteredElems.push(this[i]);
      }
    }
    return new DOM(filteredElems);
  }

  // Method to get the first element
  first() {
    return new DOM(this[0]);
  }

  // Method to get the last element
  last() {
    return new DOM(this[this.length - 1]);
  }

  // Method to get the nth element
  eq(index) {
    return new DOM(this[index]);
  }

  slice(start, end) {
    return new DOM(Array.from(this).slice(start, end));
  }

  ready(callback) {
    document.addEventListener("DOMContentLoaded", callback);
  }

  el() {
    return this[0];
  }

  sel() {
    return [...this];
  }

  hasClass(t) {
    return this && this.length > 0 ? this[0].classList.contains(t) : false;
  }
}

// Additional selectors
DOM.expr = {
  visible: (elem) => {
    return !!(
      elem.offsetWidth ||
      elem.offsetHeight ||
      elem.getClientRects().length
    );
  },
};

DOM.fn = DOM.prototype;

export const _$ = (selector) => {
  return new DOM(selector);
};
